import { observer } from 'mobx-react-lite'
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts'
import type { ConversionDetailsChartDataStore } from './store/conversionDetailsChartDataStore'

interface ConversionDetailsBarChartProps {
  chartDataStore: ConversionDetailsChartDataStore
}

export const ConversionDetailsBarChart = observer(
  ({ chartDataStore }: ConversionDetailsBarChartProps) => {
    const data = chartDataStore.rechartsData

    if (!data.length) {
      return null
    }

    return (
      <ResponsiveContainer width='100%' height={300}>
        <BarChart data={data} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
          <CartesianGrid strokeDasharray='3 3' />
          <XAxis dataKey='name' interval='preserveStartEnd' minTickGap={1} />
          <YAxis />
          <Tooltip />
          <Bar dataKey='total' fill='#0D61F2' name='Conversions' radius={[2, 2, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    )
  }
)
